import { Label } from 'components/Input/Input.styled'
import React from 'react'
import { Flex, TextDisplay } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'

interface ITextDisplayCard {
  border?: boolean
  labelText?: string
  title?: string | number
  width?: string
  style?: React.CSSProperties
}

export const TextDisplayCard = ({ labelText, title, width, border, style }: ITextDisplayCard) => {
  return (
    <Flex column width={width} style={style} >
      <Label labelText={labelText}>{labelText}</Label>
      <TextDisplay border={border} width={width}>
        <OtherText>{title}</OtherText>
      </TextDisplay>
    </Flex>
  )
}
